import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.authIssuer,
  redirectUri: window.location.origin,
  clientId: environment.authClientId,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: false,
  strictDiscoveryDocumentValidation: false, // optional, für dev
  sessionChecksEnabled: true,
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
};
